import { get, post, put, del } from "../../data/api";

// Véhicule de livraison (camion, fourgon…) : indisponibilités, annonce du véhicule et contrôle des livraisons.
// Les dates échangées sont en heure locale, sans fuseau (« 2026-10-12T09:00:00 »), comme les dates de location.

const pad = (value) => String(value).padStart(2, "0");

export function toLocalIso(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
}

export async function getDeliveryVehicleOverview(from, to) {
    return await get(`rental/delivery-vehicle/overview?from=${encodeURIComponent(toLocalIso(from))}&to=${encodeURIComponent(toLocalIso(to))}`);
}

export async function setDeliveryVehicle(toolPublicId) {
    return await put({ ToolPublicId: toolPublicId || null }, "rental/delivery-vehicle/vehicle");
}

export async function saveDeliveryVehicleUnavailability(id, { start, end, reason, note }) {
    const dto = { StartDate: toLocalIso(start), EndDate: toLocalIso(end), Reason: reason, Note: note || null };
    return id
        ? await put(dto, "rental/delivery-vehicle/unavailabilities/" + id)
        : await post(dto, "rental/delivery-vehicle/unavailabilities");
}

export async function deleteDeliveryVehicleUnavailability(id) {
    return await del("rental/delivery-vehicle/unavailabilities/" + id);
}

// Formulaire de location : start/end = Date, materials = PublicId des annonces.
export async function checkDeliveryVehicle({ start, end, delivery, materials, tripSeconds, rentalPublicId }) {
    const params = new URLSearchParams({ start: toLocalIso(start), end: toLocalIso(end), delivery: delivery || "NoDelivery" });
    if (materials?.length) params.set("materials", materials.join(","));
    if (tripSeconds > 0) params.set("tripSeconds", String(tripSeconds));
    if (rentalPublicId) params.set("rentalPublicId", rentalPublicId);
    return await get("rental/delivery-vehicle/check?" + params.toString());
}

// Agenda des réservations : récupération / restitution du camion de chaque indisponibilité saisie.
export async function getDeliveryVehicleCalendarEvents(from, to) {
    return await get(`rental/delivery-vehicle/calendar-events?from=${encodeURIComponent(toLocalIso(from))}&to=${encodeURIComponent(toLocalIso(to))}`);
}

export async function checkRentalDeliveryVehicle(rentalPublicId) {
    return await get("rental/delivery-vehicle/check/" + rentalPublicId);
}
